<div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-[calc(100vh)]">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full p-4 text-theme-text">
    <div class="flex items-center space-x-4">
      <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl"
        (onClick)="back()"></app-circle-button>
      <div class="text-lg text-theme-text font-semibold">Koppla Messenger-konto</div>
    </div>
        <!-- Instructions -->
        <div class="text-theme-text mb-6 mt-4">
          Öppna Messenger och skicka koden nedan som ett meddelande för att koppla ihop kontot
        </div>
    
        <!-- Code Panel -->
        <div class="bg-theme-surface rounded-lg shadow p-4 text-center mb-6">
          <div class="text-xl font-bold text-theme-text">{{ code }}</div>
        </div>
    
        <!-- Spinner and Status -->
        <div class="flex items-center space-x-3 text-theme-text" *ngIf="!isConnected">
          <div>
            <div class="w-6 h-6 border-4 border-theme-primary border-t-transparent rounded-full animate-spin"></div>
          </div>
          <div>Väntar på meddelande...</div>
        </div>
        <div class="flex items-center text-theme-text" *ngIf="isConnected">
          <div>Dina konton är nu ihopkopplade 👍</div>
        </div>

    <div *ngIf="isLoading"
      class="fixed top-0 bottom-0 left-0 right-0 bg-theme-surface-80 p-4 pb-safe z-10 flex items-center justify-center">
      <app-loading-spinner size="xl"></app-loading-spinner>
    </div>

  </div>
</div>